export default {
  searchText(state) {
    return state.searchText;
  },
  stringFilter(state) {
    let filter = '';
    if (state.searchText) {
      filter += `descricao like '%${state.searchText.toLowerCase()}%' or codigo like '%${state.searchText.toLowerCase()}%')`;
    }
    return filter;
  },
};
